import React from 'react';
import { Check, User, TrendingDown, Shield } from 'lucide-react';
import { Button } from './ui/button';

const ExampleCalculationSection = () => {
  const benefits = [
    'Ohne Gesundheitsprüfung',
    'Sofortleistung bei Unfalltod',
    'Testaments-, Nachlass- und Bestattungsberatung',
    'Organisation & Finanzierung der Bestattung',
    'Rückholung bei Tod im Ausland',
    'Alternativ: Kapitalzahlung möglich'
  ];

  return (
    <section className="example-calculation-section">
      <div className="container-custom">
        {/* Überschrift */}
        <div className="section-header fade-in">
          <p className="section-accent">✦ BEISPIEL-KALKULATION</p>
          <h2 className="headline-secondary">So einfach sichern Sie sich ab</h2>
          <p className="section-subtext">
            Konkrete Zahlen – transparent und fair. Ohne versteckte Kosten.
          </p>
        </div>

        {/* Haupt-Box mit Beispiel */}
        <div className="calculation-premium-box fade-in">
          <div className="calculation-grid">
            
            {/* Linke Spalte: Person & Beitrag */}
            <div className="calculation-left">
              
              {/* BEISPIEL Badge - direkt bei Lisa */}
              <div className="example-badge-inline">
                <span className="example-badge-icon">📊</span>
                <span>BEISPIEL</span>
              </div>

              {/* Persona & Absicherung kombiniert */}
              <div className="persona-combined-box">
                <div className="persona-row">
                  <div className="persona-icon">
                    <User size={20} />
                  </div>
                  <h3 className="persona-name">Lisa, 41 Jahre</h3>
                </div>
                
                <div className="insurance-row">
                  <Shield size={18} />
                  <div>
                    <p className="insurance-label">Gewünschte Absicherung</p>
                    <p className="insurance-value">10.000 EUR</p>
                  </div>
                </div>
              </div>

              {/* Monatlicher Beitrag - PROMINENT */}
              <div className="monthly-contribution">
                <p className="contribution-label">Ihr monatlicher Beitrag:</p>
                <p className="contribution-amount">23,85 EUR <span style={{ fontSize: '50%' }}>monatlich</span></p>
                <p className="contribution-note">
                  <TrendingDown size={16} />
                  Garantiert bis zum Vertragsende
                </p>
              </div>
            </div>

            {/* Rechte Spalte: Leistungen */}
            <div className="calculation-right">
              <h3 className="benefits-title">Enthaltene Leistungen</h3>
              
              <ul className="benefits-list">
                {benefits.map((benefit, index) => (
                  <li key={index} className="benefit-item">
                    <div className="benefit-check">
                      <Check size={18} />
                    </div>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>

              {/* CTA */}
              <div className="calculation-cta">
                <Button 
                  className="btn-primary btn-full-width"
                  onClick={() => {
                    // Scroll to form
                    const form = document.querySelector('.hero-form-container');
                    if (form) {
                      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    }
                  }}
                >
                  Jetzt mein Angebot anfordern
                </Button>
                <p className="cta-note">Kostenlos & unverbindlich – Antwort in 24 Stunden</p>
              </div>
            </div>
          </div>
        </div>

        {/* Zusatz-Info unterhalb */}
        <div className="calculation-info fade-in">
          <p style={{ fontSize: '0.875rem' }}>
            💡 <strong>Gut zu wissen:</strong> Ein sofortiger Start lohnt sich doppelt: günstigere Beiträge, mehr Schutz für Ihre Familie.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ExampleCalculationSection;
